import { createHashHistory } from "history";

import configureStore from "./configureStore";

const initialState = {};
export const history = createHashHistory();

export default configureStore(initialState, history);
